"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const native_1 = require("styled-components/native");
const Icons_1 = require("../Icons");
var ConnectorType;
(function (ConnectorType) {
    ConnectorType["CCS1"] = "CCS1";
    ConnectorType["CCS2"] = "CCS2";
    ConnectorType["CHADEMO"] = "CHADEMO";
    ConnectorType["COMMANDO"] = "COMMANDO";
    ConnectorType["DOMESTIC_E"] = "DOMESTIC_E";
    ConnectorType["DOMESTIC_G"] = "DOMESTIC_G";
    ConnectorType["DOMESTIC_J"] = "DOMESTIC_J";
    ConnectorType["SCHUKO"] = "SCHUKO";
    ConnectorType["TESLA"] = "TESLA";
    ConnectorType["TYPE_1"] = "TYPE_1";
    ConnectorType["TYPE_2"] = "TYPE_2";
    ConnectorType["TYPE_3A"] = "TYPE_3A";
    ConnectorType["TYPE_3C"] = "TYPE_3C";
    ConnectorType["UNKNOWN"] = "UNKNOWN";
})(ConnectorType || (ConnectorType = {}));
const ConnectorIcon = (props) => {
    const { type = '', color = 'black', width = '14', height = '20' } = props;
    const theme = native_1.useTheme();
    const ConnectorIconMap = {
        [ConnectorType.CCS2]: Icons_1.ConnectorCCS,
        [ConnectorType.CHADEMO]: Icons_1.ConnectorCHAdeMO,
        [ConnectorType.TYPE_2]: Icons_1.ConnectorType2,
        [ConnectorType.TYPE_1]: Icons_1.ConnectorType1,
        [ConnectorType.TYPE_3C]: Icons_1.ConnectorType3,
        [ConnectorType.DOMESTIC_E]: Icons_1.ConnectorWallPlug,
        [ConnectorType.DOMESTIC_G]: Icons_1.ConnectorWallPlug,
        [ConnectorType.DOMESTIC_J]: Icons_1.ConnectorWallPlug,
        [ConnectorType.UNKNOWN]: Icons_1.ConnectorUnknown,
        [ConnectorType.COMMANDO]: Icons_1.ConnectorCommando,
        [ConnectorType.CCS1]: Icons_1.ConnectorCCSComboOne,
        [ConnectorType.TYPE_3A]: Icons_1.ConnectorType3a,
        [ConnectorType.TESLA]: Icons_1.ConnectorType2,
    };
    const ConnectorIconElement = ConnectorIconMap[type];
    if (!ConnectorIconElement) {
        return (react_1.default.createElement(Icons_1.ConnectorFallback, { width: `${width}px`, height: `${height}px`, 
            // @ts-ignore
            color: color || theme.color[color] }));
    }
    return (react_1.default.createElement(ConnectorIconElement, { width: `${width}px`, height: `${height}px`, 
        // @ts-ignore
        color: color || theme.color[color] }));
};
exports.default = react_1.default.memo(ConnectorIcon);
